import { render, staticRenderFns } from "./CogAssistant.vue?vue&type=template&id=9c70a84e&scoped=true&"
import script from "./CogAssistant.vue?vue&type=script&lang=js&"
export * from "./CogAssistant.vue?vue&type=script&lang=js&"
import style0 from "../components/css/Style.css?vue&type=style&index=0&id=9c70a84e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c70a84e",
  null
  
)

export default component.exports